import { NestedKeyOf } from './type.utils';

export const buildSortParam = <T extends object>(field: NestedKeyOf<T>, mode: 'desc' | 'asc') => `${field},${mode}`;
